import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { NamedLink } from "../../components";
import css from "./MobileStepper.module.css";

const MobileStepper = ({
  currentStep,
  className,
  rootClassName,
}) => {

  const classes = classNames(
    rootClassName || css.root,
    className
  );

  return (
    <div className={classes}>

      <p className={css.stepText}>
        Step {currentStep} of 5
      </p>

      <div className={css.progress}>

        {[1,2,3,4,5].map((step,index)=>(
          <React.Fragment key={step}>

            <div
              className={classNames(css.circle, {
                [css.active]: currentStep === step,
                [css.completed]: currentStep > step,
              })}
            >
              {currentStep > step ? '✓' : step}
            </div>

            {index !== 4 && (
              <div
                className={`${css.line}
                ${currentStep > step ? css.activeLine : ""}`}
              />
            )}

          </React.Fragment>
        ))}

      </div>

      <p className={css.loginLink}>
        Already have an account? <NamedLink name="LoginPage">Log in</NamedLink>
      </p>

    </div>
  );
};

MobileStepper.defaultProps = {
  currentStep:1,
  className:null,
  rootClassName:null
};

MobileStepper.propTypes = {
  currentStep:PropTypes.number,
  className:PropTypes.string,
  rootClassName:PropTypes.string
};

export default MobileStepper;